import { KeycloakService } from '../services/keycloak.service'
import { environment } from '../../../environments/environment'

export function keycloakInitializerFactory(keycloakService: KeycloakService) {
  return async () => {
    if (environment.keycloakEnabled) {
      try {
        const authenticated = await keycloakService.init()
        console.log('Keycloak initialized. Authenticated:', authenticated)
      } catch (error) {
        console.error('Keycloak initialization failed:', error)
        throw error
      }
    }
  }
}
